// extracted by mini-css-extract-plugin
export default {"container":"stocks_container__mCbpG","stocks":"stocks_stocks__qkc0p","my_swiper":"stocks_my_swiper__VVScp"};